import { render, staticRenderFns } from "./AccountSettingLottery.vue?vue&type=template&id=79e6d4f6&"
import script from "./AccountSettingLottery.vue?vue&type=script&lang=js&"
export * from "./AccountSettingLottery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports